import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { AppDispatch } from "@/store"
import { updateUnitTTPSThunk } from "@/store/flowsheet/actions"
import { RunState, getFlowSimulationSelector, getStatus, getTopologyState } from "@/store/flowsheet/flowsheet.slice"
import { Select } from "antd"
import { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

interface PropertySetSelectProps {
  unitId: string
  value?: string
  onChanged?: () => void
  title?: string
  disabled?: boolean
}

export const PropertySetSelect = (props: PropertySetSelectProps) => {
  const {unitId, value: initVal, title, disabled = false} = props
  const status = useSelector(getStatus)
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const simulationData = useSelector(getTopologyState)
  const [value, setValue] = useState(initVal)
  const dispatch = useDispatch<AppDispatch>()
  const tpps = simulationData?.tpps || []
  const options = tpps.map(item => {
    return {value: item, label: item}
  })

  useEffect(() => {
    setValue(initVal)
  }, [initVal])

  const changeUnitPS = async (pName: string) => {
    setValue(pName)
    if (!flowSimulation) return;
    dispatch(updateUnitTTPSThunk({
      data: {unit: unitId, tpps: pName},
      params: {sId: flowSimulation.id}
    }))
  }

  return <div className="flex-space-btw mt-1">
    <div>{title || 'Property Set'}</div>
    <div>
      <Select
        disabled={status === RunState.Stop || disabled || options.length === 0}
        style={{width: 150}}
        value={value}
        placeholder="Select a Property Set"
        onChange={changeUnitPS}
        options={options}
      />
  </div>
  </div>
}